import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { cn } from "@/lib/utils";

/** Multi-thumb slider — renders one Thumb per value in `value` or `defaultValue`. */
const RangeSlider = React.forwardRef(({ className, value, defaultValue, ...props }, ref) => {
  const vals = value ?? defaultValue ?? [0, 100];
  return (
    <SliderPrimitive.Root
      ref={ref}
      value={value}
      defaultValue={defaultValue}
      className={cn("relative flex w-full touch-none select-none items-center", className)}
      {...props}
    >
      <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-white/10">
        <SliderPrimitive.Range className="absolute h-full bg-[#FF3B00]" />
      </SliderPrimitive.Track>
      {vals.map((_, i) => (
        <SliderPrimitive.Thumb
          key={i}
          className="block h-4 w-4 rounded-full border-2 border-[#FF3B00] bg-black shadow-lg transition-transform hover:scale-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF3B00]/50 disabled:pointer-events-none disabled:opacity-50"
        />
      ))}
    </SliderPrimitive.Root>
  );
});
RangeSlider.displayName = "RangeSlider";

export { RangeSlider };
